/**
 * Stable day identifier for live data (notes, expenses, journal).
 * Matches plan_days.date as ISO string.
 */
export function toDayKey(date) {
  if (typeof date === 'string') {
    return date.slice(0, 10);
  }
  if (date instanceof Date) {
    return date.toISOString().slice(0, 10);
  }
  return String(date);
}

export function isValidDayKey(dayKey) {
  return /^\d{4}-\d{2}-\d{2}$/.test(dayKey);
}
